export const environment = {
  production: true,
  STAGING_URL: '',
  SENTRY_ENV: 'production'
};

